import{createTheme as e}from"./createTheme.js";export{createTheme}from"./createTheme.js";import{baseTheme as m}from"./baseTheme.js";var r=e({name:"default-theme"},m);export{r as defaultTheme};
//# sourceMappingURL=index.js.map
